const STAMPED_RELEASE =
  document
    .querySelector<HTMLMetaElement>('meta[name="app-release"]')
    ?.getAttribute('content') ?? '';

// Stamped into index.html by the emit-release plugin; an unstamped one still holds the placeholder.
export const APP_VERSION = STAMPED_RELEASE.startsWith('__APP_')
  ? ''
  : STAMPED_RELEASE;
